import { FormControl, FormErrorMessage } from '@chakra-ui/react';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

import { AlertCircleIcon } from '@/imports/ui/chakra/feather';

import { FileUploadPreview } from './components';

export const AttachmentPreview: React.FC = () => {
  const methods = useFormContext();
  const {
    watch,
    setValue,
    formState: { errors },
  } = methods;
  const attachments = watch('attachments');

  return attachments.length ? (
    <FormControl isInvalid={!!errors.attachments?.message}>
      <FileUploadPreview
        attachments={attachments}
        onClick={(value: { versionFileId: string }) => {
          setValue(
            'attachments',
            attachments.filter((resource: { versionFileId: string }) => {
              return resource.versionFileId !== value.versionFileId;
            }),
            { shouldValidate: true }
          );
        }}
      />
      <FormErrorMessage>
        <AlertCircleIcon mr="2" />
        {errors.attachments?.message}
      </FormErrorMessage>
    </FormControl>
  ) : null;
};
